package com.hyperether.goodjob.repository

import com.hyperether.goodjob.models.Contact
import kotlinx.coroutines.flow.MutableStateFlow
import kotlinx.coroutines.flow.StateFlow

object IndustryManager {

    private val _industries = MutableStateFlow<List<String>>(emptyList())
    val industries: StateFlow<List<String>> = _industries

    fun setIndustriesFromContacts(contacts: List<Contact>?) {
        if (contacts == null) {
            _industries.value = emptyList()
            return
        }

        val industries = contacts.mapNotNull { it.industry?.trim() }
            .filter { it.isNotBlank() }
            .distinct()
            .sorted()

        _industries.value = industries
    }

    fun addIndustry(industry: String) {
        val trimmedIndustry = industry.trim()
        if (trimmedIndustry.isNotBlank() && !_industries.value.contains(trimmedIndustry)) {
            _industries.value += trimmedIndustry
        }
    }
}